var map = {
	"./da/account-lock.json": [
		77243,
		77243
	],
	"./da/account-settings-navigation.json": [
		76306,
		76306
	],
	"./da/account-verification.json": [
		94247,
		94247
	],
	"./da/automatic-logout.json": [
		79254,
		79254
	],
	"./da/contact-us.json": [
		93913,
		93913
	],
	"./da/credit-rating.json": [
		97515,
		97515
	],
	"./da/document-expiration.json": [
		70171,
		70171
	],
	"./da/email-change.json": [
		72281,
		72281
	],
	"./da/login.json": [
		62011,
		62011
	],
	"./da/my-limits.json": [
		67099,
		67099
	],
	"./da/mybets.json": [
		26516,
		26516
	],
	"./da/notification-settings.json": [
		90505,
		90505
	],
	"./da/password-change.json": [
		39714,
		39714
	],
	"./da/payment.json": [
		40148,
		40148
	],
	"./da/personal-data.json": [
		45333,
		45333
	],
	"./da/registration.json": [
		86391,
		86391
	],
	"./da/translation.json": [
		26837,
		26837
	],
	"./da/translation.twat-betax-mobile.json": [
		45935,
		45935
	],
	"./da/translation.twat-betax.json": [
		32894,
		32894
	],
	"./da/translation.twat-mobile.json": [
		42722,
		42722
	],
	"./da/translation.twat.json": [
		68077,
		68077
	],
	"./da/translation.twcom-mobile.json": [
		97402,
		97402
	],
	"./da/translation.twcom.json": [
		47781,
		47781
	],
	"./da/translation.twde-games-mobile.json": [
		79678,
		79678
	],
	"./da/translation.twde-games.json": [
		94857,
		94857
	],
	"./da/translation.twde-mobile.json": [
		9768,
		9768
	],
	"./da/translation.twde.json": [
		27319,
		27319
	],
	"./da/translation.twdk-mobile.json": [
		32610,
		32610
	],
	"./da/translation.twdk.json": [
		39437,
		39437
	],
	"./da/translation.twse-mobile.json": [
		55506,
		33125
	],
	"./da/translation.twse.json": [
		56232,
		56232
	],
	"./da/translation.vip-mobile.json": [
		39621,
		39621
	],
	"./da/translation.vip.json": [
		3016,
		3016
	],
	"./da/user-account.json": [
		20155,
		20155
	],
	"./de/account-lock.json": [
		39063,
		39063
	],
	"./de/account-settings-navigation.json": [
		68038,
		68038
	],
	"./de/account-verification.json": [
		59299,
		59299
	],
	"./de/automatic-logout.json": [
		41562,
		41562
	],
	"./de/contact-us.json": [
		29309,
		29309
	],
	"./de/credit-rating.json": [
		73439,
		73439
	],
	"./de/document-expiration.json": [
		14023,
		14023
	],
	"./de/email-change.json": [
		47013,
		47013
	],
	"./de/login.json": [
		7479,
		7479
	],
	"./de/my-limits.json": [
		69263,
		69263
	],
	"./de/mybets.json": [
		77216,
		77216
	],
	"./de/notification-settings.json": [
		30685,
		30685
	],
	"./de/password-change.json": [
		182,
		182
	],
	"./de/payment.json": [
		92208,
		92208
	],
	"./de/personal-data.json": [
		93369,
		93369
	],
	"./de/registration.json": [
		72187,
		72187
	],
	"./de/translation.json": [
		15713,
		15713
	],
	"./de/translation.twat-betax-mobile.json": [
		78635,
		78635
	],
	"./de/translation.twat-betax.json": [
		42458,
		42458
	],
	"./de/translation.twat-mobile.json": [
		47222,
		47222
	],
	"./de/translation.twat.json": [
		25761,
		25761
	],
	"./de/translation.twcom-mobile.json": [
		28942,
		28942
	],
	"./de/translation.twcom.json": [
		45689,
		45689
	],
	"./de/translation.twde-games-mobile.json": [
		17162,
		17162
	],
	"./de/translation.twde-games.json": [
		90997,
		90997
	],
	"./de/translation.twde-mobile.json": [
		89060,
		89060
	],
	"./de/translation.twde.json": [
		3555,
		3555
	],
	"./de/translation.twdk-mobile.json": [
		35062,
		35062
	],
	"./de/translation.twdk.json": [
		32705,
		32705
	],
	"./de/translation.twse-mobile.json": [
		1321,
		1321
	],
	"./de/translation.twse.json": [
		15244,
		15244
	],
	"./de/translation.vip-mobile.json": [
		72017,
		72017
	],
	"./de/translation.vip.json": [
		61863,
		84244
	],
	"./de/user-account.json": [
		48231,
		48231
	],
	"./en/account-lock.json": [
		21923,
		21923
	],
	"./en/account-settings-navigation.json": [
		85274,
		85274
	],
	"./en/account-verification.json": [
		93615,
		15996
	],
	"./en/automatic-logout.json": [
		88750,
		88750
	],
	"./en/contact-us.json": [
		67729,
		67729
	],
	"./en/credit-rating.json": [
		40035,
		40035
	],
	"./en/document-expiration.json": [
		62627,
		62627
	],
	"./en/email-change.json": [
		17473,
		17473
	],
	"./en/login.json": [
		62067,
		62067
	],
	"./en/my-limits.json": [
		8675,
		8675
	],
	"./en/mybets.json": [
		84028,
		84028
	],
	"./en/notification-settings.json": [
		26849,
		26849
	],
	"./en/password-change.json": [
		1562,
		1562
	],
	"./en/payment.json": [
		40924,
		40924
	],
	"./en/personal-data.json": [
		99885,
		99885
	],
	"./en/registration.json": [
		47743,
		47743
	],
	"./en/translation.json": [
		9661,
		9661
	],
	"./en/translation.twat-betax-mobile.json": [
		89463,
		89463
	],
	"./en/translation.twat-betax.json": [
		71398,
		71398
	],
	"./en/translation.twat-mobile.json": [
		34858,
		34858
	],
	"./en/translation.twat.json": [
		66549,
		66549
	],
	"./en/translation.twcom-mobile.json": [
		81490,
		81490
	],
	"./en/translation.twcom.json": [
		77469,
		77469
	],
	"./en/translation.twde-games-mobile.json": [
		10022,
		10022
	],
	"./en/translation.twde-games.json": [
		72305,
		72305
	],
	"./en/translation.twde-mobile.json": [
		8656,
		8656
	],
	"./en/translation.twde.json": [
		87327,
		87327
	],
	"./en/translation.twdk-mobile.json": [
		3642,
		3642
	],
	"./en/translation.twdk.json": [
		23858,
		1477
	],
	"./en/translation.twse-mobile.json": [
		22861,
		22861
	],
	"./en/translation.twse.json": [
		41232,
		41232
	],
	"./en/translation.vip-mobile.json": [
		14413,
		14413
	],
	"./en/translation.vip.json": [
		68624,
		68624
	],
	"./en/user-account.json": [
		67827,
		67827
	],
	"./es/account-lock.json": [
		42522,
		42522
	],
	"./es/account-settings-navigation.json": [
		33129,
		33129
	],
	"./es/account-verification.json": [
		51998,
		51998
	],
	"./es/automatic-logout.json": [
		71647,
		71647
	],
	"./es/contact-us.json": [
		74716,
		74716
	],
	"./es/credit-rating.json": [
		23192,
		23192
	],
	"./es/document-expiration.json": [
		51260,
		51260
	],
	"./es/email-change.json": [
		70636,
		70636
	],
	"./es/login.json": [
		77040,
		77040
	],
	"./es/my-limits.json": [
		68884,
		68884
	],
	"./es/mybets.json": [
		1445,
		1445
	],
	"./es/notification-settings.json": [
		14162,
		14162
	],
	"./es/password-change.json": [
		45113,
		45113
	],
	"./es/payment.json": [
		32111,
		32111
	],
	"./es/personal-data.json": [
		97462,
		97462
	],
	"./es/registration.json": [
		90962,
		90962
	],
	"./es/translation.json": [
		5366,
		5366
	],
	"./es/translation.twat-betax-mobile.json": [
		29808,
		29808
	],
	"./es/translation.twat-betax.json": [
		45407,
		45407
	],
	"./es/translation.twat-mobile.json": [
		32541,
		32541
	],
	"./es/translation.twat.json": [
		3072,
		3072
	],
	"./es/translation.twcom-mobile.json": [
		98803,
		98803
	],
	"./es/translation.twcom.json": [
		20898,
		20898
	],
	"./es/translation.twde-games-mobile.json": [
		41961,
		41961
	],
	"./es/translation.twde-games.json": [
		78284,
		78284
	],
	"./es/translation.twde-mobile.json": [
		10071,
		10071
	],
	"./es/translation.twde.json": [
		7654,
		7654
	],
	"./es/translation.twdk-mobile.json": [
		413,
		413
	],
	"./es/translation.twdk.json": [
		1312,
		1312
	],
	"./es/translation.twse-mobile.json": [
		60254,
		60254
	],
	"./es/translation.twse.json": [
		27977,
		27977
	],
	"./es/translation.vip-mobile.json": [
		35872,
		35872
	],
	"./es/translation.vip.json": [
		60847,
		60847
	],
	"./es/user-account.json": [
		52038,
		52038
	],
	"./fr/account-lock.json": [
		42098,
		42098
	],
	"./fr/account-settings-navigation.json": [
		26766,
		4385
	],
	"./fr/account-verification.json": [
		67798,
		67798
	],
	"./fr/automatic-logout.json": [
		40583,
		40583
	],
	"./fr/contact-us.json": [
		34596,
		34596
	],
	"./fr/credit-rating.json": [
		54976,
		54976
	],
	"./fr/document-expiration.json": [
		48596,
		48596
	],
	"./fr/email-change.json": [
		96036,
		96036
	],
	"./fr/login.json": [
		21944,
		21944
	],
	"./fr/my-limits.json": [
		1548,
		1548
	],
	"./fr/mybets.json": [
		76893,
		76893
	],
	"./fr/notification-settings.json": [
		34810,
		34810
	],
	"./fr/password-change.json": [
		13633,
		13633
	],
	"./fr/payment.json": [
		44359,
		44359
	],
	"./fr/personal-data.json": [
		64414,
		64414
	],
	"./fr/registration.json": [
		39370,
		39370
	],
	"./fr/translation.json": [
		5710,
		5710
	],
	"./fr/translation.twat-betax-mobile.json": [
		49512,
		49512
	],
	"./fr/translation.twat-betax.json": [
		28151,
		28151
	],
	"./fr/translation.twat-mobile.json": [
		80341,
		80341
	],
	"./fr/translation.twat.json": [
		29144,
		29144
	],
	"./fr/translation.twcom-mobile.json": [
		37083,
		37083
	],
	"./fr/translation.twcom.json": [
		15434,
		15434
	],
	"./fr/translation.twde-games-mobile.json": [
		2465,
		2465
	],
	"./fr/translation.twde-games.json": [
		62820,
		62820
	],
	"./fr/translation.twde-mobile.json": [
		98767,
		98767
	],
	"./fr/translation.twde.json": [
		18814,
		18814
	],
	"./fr/translation.twdk-mobile.json": [
		28901,
		28901
	],
	"./fr/translation.twdk.json": [
		98664,
		98664
	],
	"./fr/translation.twse-mobile.json": [
		78454,
		78454
	],
	"./fr/translation.twse.json": [
		70913,
		70913
	],
	"./fr/translation.vip-mobile.json": [
		13336,
		13336
	],
	"./fr/translation.vip.json": [
		1927,
		1927
	],
	"./fr/user-account.json": [
		14830,
		14830
	],
	"./hr/account-lock.json": [
		47372,
		47372
	],
	"./hr/account-settings-navigation.json": [
		90927,
		90927
	],
	"./hr/account-verification.json": [
		61132,
		61132
	],
	"./hr/automatic-logout.json": [
		94521,
		94521
	],
	"./hr/contact-us.json": [
		68542,
		68542
	],
	"./hr/credit-rating.json": [
		93942,
		93942
	],
	"./hr/document-expiration.json": [
		96094,
		96094
	],
	"./hr/email-change.json": [
		44742,
		44742
	],
	"./hr/login.json": [
		79918,
		79918
	],
	"./hr/my-limits.json": [
		88202,
		88202
	],
	"./hr/mybets.json": [
		47675,
		47675
	],
	"./hr/notification-settings.json": [
		6996,
		6996
	],
	"./hr/password-change.json": [
		95803,
		95803
	],
	"./hr/payment.json": [
		40189,
		40189
	],
	"./hr/personal-data.json": [
		85192,
		85192
	],
	"./hr/registration.json": [
		65384,
		65384
	],
	"./hr/translation.json": [
		98892,
		98892
	],
	"./hr/translation.twat-betax-mobile.json": [
		18402,
		18402
	],
	"./hr/translation.twat-betax.json": [
		70477,
		70477
	],
	"./hr/translation.twat-mobile.json": [
		61763,
		61763
	],
	"./hr/translation.twat.json": [
		50866,
		28485
	],
	"./hr/translation.twcom-mobile.json": [
		74573,
		74573
	],
	"./hr/translation.twcom.json": [
		27312,
		27312
	],
	"./hr/translation.twde-games-mobile.json": [
		88791,
		88791
	],
	"./hr/translation.twde-games.json": [
		14662,
		14662
	],
	"./hr/translation.twde-mobile.json": [
		14821,
		14821
	],
	"./hr/translation.twde.json": [
		5032,
		5032
	],
	"./hr/translation.twdk-mobile.json": [
		15535,
		15535
	],
	"./hr/translation.twdk.json": [
		8830,
		8830
	],
	"./hr/translation.twse-mobile.json": [
		98440,
		98440
	],
	"./hr/translation.twse.json": [
		67383,
		67383
	],
	"./hr/translation.vip-mobile.json": [
		78034,
		78034
	],
	"./hr/translation.vip.json": [
		15773,
		15773
	],
	"./hr/user-account.json": [
		24404,
		24404
	],
	"./it/account-lock.json": [
		36481,
		36481
	],
	"./it/account-settings-navigation.json": [
		54476,
		54476
	],
	"./it/account-verification.json": [
		69369,
		69369
	],
	"./it/automatic-logout.json": [
		8412,
		8412
	],
	"./it/contact-us.json": [
		93039,
		93039
	],
	"./it/credit-rating.json": [
		66469,
		66469
	],
	"./it/document-expiration.json": [
		87417,
		87417
	],
	"./it/email-change.json": [
		2471,
		2471
	],
	"./it/login.json": [
		77973,
		77973
	],
	"./it/my-limits.json": [
		173,
		173
	],
	"./it/mybets.json": [
		67206,
		67206
	],
	"./it/notification-settings.json": [
		39599,
		39599
	],
	"./it/password-change.json": [
		81600,
		81600
	],
	"./it/payment.json": [
		91462,
		91462
	],
	"./it/personal-data.json": [
		19027,
		19027
	],
	"./it/registration.json": [
		27025,
		27025
	],
	"./it/translation.json": [
		6751,
		6751
	],
	"./it/translation.twat-betax-mobile.json": [
		24565,
		24565
	],
	"./it/translation.twat-betax.json": [
		95448,
		95448
	],
	"./it/translation.twat-mobile.json": [
		13060,
		13060
	],
	"./it/translation.twat.json": [
		50019,
		50019
	],
	"./it/translation.twcom-mobile.json": [
		31520,
		31520
	],
	"./it/translation.twcom.json": [
		87695,
		87695
	],
	"./it/translation.twde-games-mobile.json": [
		16448,
		16448
	],
	"./it/translation.twde-games.json": [
		57967,
		57967
	],
	"./it/translation.twde-mobile.json": [
		53930,
		53930
	],
	"./it/translation.twde.json": [
		23061,
		23061
	],
	"./it/translation.twdk-mobile.json": [
		29568,
		29568
	],
	"./it/translation.twdk.json": [
		84591,
		84591
	],
	"./it/translation.twse-mobile.json": [
		21355,
		21355
	],
	"./it/translation.twse.json": [
		98938,
		98938
	],
	"./it/translation.vip-mobile.json": [
		96555,
		96555
	],
	"./it/translation.vip.json": [
		30234,
		30234
	],
	"./it/user-account.json": [
		15469,
		15469
	],
	"./nl/account-lock.json": [
		2960,
		2960
	],
	"./nl/account-settings-navigation.json": [
		25915,
		25915
	],
	"./nl/account-verification.json": [
		75504,
		75504
	],
	"./nl/automatic-logout.json": [
		3733,
		3733
	],
	"./nl/contact-us.json": [
		30186,
		30186
	],
	"./nl/credit-rating.json": [
		35154,
		35154
	],
	"./nl/document-expiration.json": [
		87890,
		87890
	],
	"./nl/email-change.json": [
		13818,
		13818
	],
	"./nl/login.json": [
		52386,
		52386
	],
	"./nl/my-limits.json": [
		47238,
		47238
	],
	"./nl/mybets.json": [
		51199,
		51199
	],
	"./nl/notification-settings.json": [
		25856,
		25856
	],
	"./nl/password-change.json": [
		51575,
		51575
	],
	"./nl/payment.json": [
		85041,
		85041
	],
	"./nl/personal-data.json": [
		12788,
		12788
	],
	"./nl/registration.json": [
		36356,
		36356
	],
	"./nl/translation.json": [
		40432,
		40432
	],
	"./nl/translation.twat-betax-mobile.json": [
		28310,
		28310
	],
	"./nl/translation.twat-betax.json": [
		95585,
		95585
	],
	"./nl/translation.twat-mobile.json": [
		89231,
		89231
	],
	"./nl/translation.twat.json": [
		56510,
		56510
	],
	"./nl/translation.twcom-mobile.json": [
		37097,
		37097
	],
	"./nl/translation.twcom.json": [
		31820,
		31820
	],
	"./nl/translation.twde-games-mobile.json": [
		667,
		667
	],
	"./nl/translation.twde-games.json": [
		98378,
		98378
	],
	"./nl/translation.twde-mobile.json": [
		67673,
		67673
	],
	"./nl/translation.twde.json": [
		55644,
		55644
	],
	"./nl/translation.twdk-mobile.json": [
		75547,
		75547
	],
	"./nl/translation.twdk.json": [
		53258,
		53258
	],
	"./nl/translation.twse-mobile.json": [
		88788,
		88788
	],
	"./nl/translation.twse.json": [
		6675,
		6675
	],
	"./nl/translation.vip-mobile.json": [
		67878,
		67878
	],
	"./nl/translation.vip.json": [
		92241,
		92241
	],
	"./nl/user-account.json": [
		67096,
		67096
	],
	"./sq/account-lock.json": [
		31038,
		31038
	],
	"./sq/account-settings-navigation.json": [
		65173,
		65173
	],
	"./sq/account-verification.json": [
		91314,
		91314
	],
	"./sq/automatic-logout.json": [
		39899,
		39899
	],
	"./sq/contact-us.json": [
		74232,
		74232
	],
	"./sq/credit-rating.json": [
		95508,
		95508
	],
	"./sq/document-expiration.json": [
		87952,
		87952
	],
	"./sq/email-change.json": [
		30272,
		30272
	],
	"./sq/login.json": [
		26804,
		26804
	],
	"./sq/my-limits.json": [
		50496,
		50496
	],
	"./sq/mybets.json": [
		46969,
		46969
	],
	"./sq/notification-settings.json": [
		18110,
		18110
	],
	"./sq/password-change.json": [
		51461,
		51461
	],
	"./sq/payment.json": [
		85555,
		85555
	],
	"./sq/personal-data.json": [
		35762,
		35762
	],
	"./sq/registration.json": [
		75582,
		75582
	],
	"./sq/translation.json": [
		11930,
		11930
	],
	"./sq/translation.twat-betax-mobile.json": [
		28340,
		28340
	],
	"./sq/translation.twat-betax.json": [
		72627,
		72627
	],
	"./sq/translation.twat-mobile.json": [
		77433,
		77433
	],
	"./sq/translation.twat.json": [
		98972,
		98972
	],
	"./sq/translation.twcom-mobile.json": [
		82495,
		82495
	],
	"./sq/translation.twcom.json": [
		54222,
		31841
	],
	"./sq/translation.twde-games-mobile.json": [
		93789,
		93789
	],
	"./sq/translation.twde-games.json": [
		14912,
		14912
	],
	"./sq/translation.twde-mobile.json": [
		7499,
		7499
	],
	"./sq/translation.twde.json": [
		66426,
		66426
	],
	"./sq/translation.twdk-mobile.json": [
		12521,
		12521
	],
	"./sq/translation.twdk.json": [
		94348,
		94348
	],
	"./sq/translation.twse-mobile.json": [
		25898,
		25898
	],
	"./sq/translation.twse.json": [
		6901,
		6901
	],
	"./sq/translation.vip-mobile.json": [
		77540,
		77540
	],
	"./sq/translation.vip.json": [
		57763,
		57763
	],
	"./sq/user-account.json": [
		1722,
		1722
	],
	"./sv/account-lock.json": [
		74065,
		74065
	],
	"./sv/account-settings-navigation.json": [
		36956,
		36956
	],
	"./sv/account-verification.json": [
		55945,
		55945
	],
	"./sv/automatic-logout.json": [
		21964,
		21964
	],
	"./sv/contact-us.json": [
		9823,
		9823
	],
	"./sv/credit-rating.json": [
		90005,
		90005
	],
	"./sv/document-expiration.json": [
		38217,
		38217
	],
	"./sv/email-change.json": [
		42967,
		42967
	],
	"./sv/login.json": [
		78725,
		1106
	],
	"./sv/my-limits.json": [
		40925,
		40925
	],
	"./sv/mybets.json": [
		94774,
		94774
	],
	"./sv/notification-settings.json": [
		75071,
		75071
	],
	"./sv/password-change.json": [
		93392,
		93392
	],
	"./sv/payment.json": [
		71798,
		71798
	],
	"./sv/personal-data.json": [
		67363,
		67363
	],
	"./sv/registration.json": [
		32129,
		32129
	],
	"./sv/translation.json": [
		80047,
		80047
	],
	"./sv/translation.twat-betax-mobile.json": [
		99941,
		99941
	],
	"./sv/translation.twat-betax.json": [
		48008,
		48008
	],
	"./sv/translation.twat-mobile.json": [
		3700,
		3700
	],
	"./sv/translation.twat.json": [
		41459,
		41459
	],
	"./sv/translation.twcom-mobile.json": [
		59312,
		59312
	],
	"./sv/translation.twcom.json": [
		97247,
		97247
	],
	"./sv/translation.twde-games-mobile.json": [
		47920,
		47920
	],
	"./sv/translation.twde-games.json": [
		91551,
		91551
	],
	"./sv/translation.twde-mobile.json": [
		96538,
		96538
	],
	"./sv/translation.twde.json": [
		30597,
		30597
	],
	"./sv/translation.twdk-mobile.json": [
		49744,
		49744
	],
	"./sv/translation.twdk.json": [
		16447,
		16447
	],
	"./sv/translation.twse-mobile.json": [
		47259,
		47259
	],
	"./sv/translation.twse.json": [
		41738,
		41738
	],
	"./sv/translation.vip-mobile.json": [
		40187,
		40187
	],
	"./sv/translation.vip.json": [
		33290,
		33290
	],
	"./sv/user-account.json": [
		9853,
		9853
	],
	"./tr/account-lock.json": [
		88872,
		88872
	],
	"./tr/account-settings-navigation.json": [
		66803,
		66803
	],
	"./tr/account-verification.json": [
		26984,
		26984
	],
	"./tr/automatic-logout.json": [
		12733,
		12733
	],
	"./tr/contact-us.json": [
		61714,
		61714
	],
	"./tr/credit-rating.json": [
		38202,
		38202
	],
	"./tr/document-expiration.json": [
		74698,
		74698
	],
	"./tr/email-change.json": [
		55890,
		55890
	],
	"./tr/login.json": [
		82762,
		82762
	],
	"./tr/my-limits.json": [
		4606,
		4606
	],
	"./tr/mybets.json": [
		62263,
		62263
	],
	"./tr/notification-settings.json": [
		52872,
		52872
	],
	"./tr/password-change.json": [
		2559,
		2559
	],
	"./tr/payment.json": [
		93193,
		93193
	],
	"./tr/personal-data.json": [
		37116,
		37116
	],
	"./tr/registration.json": [
		90492,
		90492
	],
	"./tr/translation.json": [
		40744,
		40744
	],
	"./tr/translation.twat-betax-mobile.json": [
		84462,
		84462
	],
	"./tr/translation.twat-betax.json": [
		68697,
		68697
	],
	"./tr/translation.twat-mobile.json": [
		14983,
		14983
	],
	"./tr/translation.twat.json": [
		17942,
		17942
	],
	"./tr/translation.twcom-mobile.json": [
		32433,
		32433
	],
	"./tr/translation.twcom.json": [
		46484,
		46484
	],
	"./tr/translation.twde-games-mobile.json": [
		88435,
		88435
	],
	"./tr/translation.twde-games.json": [
		54242,
		54242
	],
	"./tr/translation.twde-mobile.json": [
		10417,
		10417
	],
	"./tr/translation.twde.json": [
		82484,
		82484
	],
	"./tr/translation.twdk-mobile.json": [
		15747,
		15747
	],
	"./tr/translation.twdk.json": [
		7506,
		7506
	],
	"./tr/translation.twse-mobile.json": [
		37100,
		37100
	],
	"./tr/translation.twse.json": [
		91627,
		91627
	],
	"./tr/translation.vip-mobile.json": [
		47102,
		47102
	],
	"./tr/translation.vip.json": [
		65961,
		65961
	],
	"./tr/user-account.json": [
		27008,
		27008
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45019;
module.exports = webpackAsyncContext;